<!--
 * @Author: Christion.Young
 * @Date: 2025-07-30 10:00:00
 * @LastEditors: Christion.Young
 * @LastEditTime: 2025-07-30 10:00:00
 * @Description: 404错误页面
 * @Features:
 *   - 友好的错误提示
 *   - 返回首页按钮
 *   - 响应式设计
-->

<template>

  <div class="error-page">

    <div class="error-container">

      <div class="error-content">

        <div class="error-icon">

          <i class="el-icon-warning"></i>

        </div>

        <h1 class="error-title">页面未找到</h1>

        <p class="error-message"> 抱歉，您访问的页面不存在或已被移除 </p>

        <div class="error-actions">

          <button class="error-action-btn error-primary" @click="goHome">

            <i class="el-icon-s-home"></i>
             返回首页
          </button>

          <button class="error-action-btn" @click="goBack">

            <i class="el-icon-back"></i>
             返回上页
          </button>

        </div>

      </div>

    </div>

  </div>

</template>

<script>
export default {
  name: "404",
  mounted() {
    // 记录404错误到控制台
    console.warn("404页面访问:", {
      path: this.$route.path,
      fullPath: this.$route.fullPath,
      query: this.$route.query,
      params: this.$route.params,
      referrer: document.referrer,
    });
  },
  methods: {
    /**
     * 返回首页
     */
    goHome() {
      this.$router.push("/").catch((err) => {
        console.error("从404页面跳转到首页失败:", err);
        // 如果路由跳转失败，使用原生跳转
        window.location.href = "/";
      });
    },

    /**
     * 返回上一页
     */
    goBack() {
      if (window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.goHome();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.error-container {
  text-align: center;
  padding: 40px;
}

.error-content {
  max-width: 500px;
  margin: 0 auto;
}

.error-icon {
  font-size: 120px;
  color: #f56c6c;
  margin-bottom: 30px;

  i {
    display: block;
  }
}

.error-title {
  font-size: 36px;
  font-weight: 600;
  color: #2c3e50;
  margin-bottom: 16px;
}

.error-message {
  font-size: 18px;
  color: #7f8c8d;
  margin-bottom: 40px;
  line-height: 1.6;
}

.error-actions {
  display: flex;
  gap: 16px;
  justify-content: center;

  .error-action-btn {
    padding: 12px 24px;
    font-size: 16px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.3s ease;
    background: #fff;
    color: #606266;
    border: 1px solid #dcdfe6;

    &.error-primary {
      background: #e74c3c;
      color: white;
      border-color: #e74c3c;

      &:hover {
        background: #c0392b;
        border-color: #c0392b;
      }
    }

    &:hover {
      color: #e74c3c;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }

    i {
      margin-right: 6px;
    }
  }
}
</style>

